import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendarToday = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "calendar_today",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1238_7319",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 20,
				height: 20,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_1238_7319)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "calendar_today_2",
				d: "M4.16667 18.3334C3.70833 18.3334 3.31597 18.1702 2.98958 17.8438C2.66319 17.5174 2.5 17.125 2.5 16.6667V5.00002C2.5 4.54169 2.66319 4.14933 2.98958 3.82294C3.31597 3.49655 3.70833 3.33335 4.16667 3.33335H5V1.66669H6.66667V3.33335H13.3333V1.66669H15V3.33335H15.8333C16.2917 3.33335 16.684 3.49655 17.0104 3.82294C17.3368 4.14933 17.5 4.54169 17.5 5.00002V16.6667C17.5 17.125 17.3368 17.5174 17.0104 17.8438C16.684 18.1702 16.2917 18.3334 15.8333 18.3334H4.16667ZM4.16667 16.6667H15.8333V8.33335H4.16667V16.6667ZM4.16667 6.66669H15.8333V5.00002H4.16667V6.66669Z",
				fill: "#556C75"
			})
		})]
	})
});
export default SvgCalendarToday;
